import { render, staticRenderFns } from "./DepartDataruleModal.vue?vue&type=template&id=371269a2&scoped=true&"
import script from "./DepartDataruleModal.vue?vue&type=script&lang=js&"
export * from "./DepartDataruleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371269a2",
  null
  
)

export default component.exports